/**
 * Shared client-side ecosystem SEO helpers (CRA SPA — not framework SSR).
 *
 * Crawler-visible robots for first HTML paint come from nginx + /api/meta.
 * This module keeps post-hydration <meta name="robots"> aligned.
 */

export const ECOSYSTEM_PATH_PREFIXES = [
  "/ecosystem/robinhood",
  "/chain/robinhood",
  "/ecosystem/base",
  "/chain/base",
  "/ecosystem/solana",
  "/chain/solana",
];

export function isEcosystemPagePath(pathname) {
  const p = String(pathname || "/").split("?")[0].split("#")[0] || "/";
  return ECOSYSTEM_PATH_PREFIXES.some((prefix) => p === prefix || p.startsWith(`${prefix}/`));
}

/**
 * Staging / non-production hosts must never be indexed.
 * Production + intentionally public ecosystem pages may index later.
 */
export function ecosystemRobotsForHost(hostname, { productionPublic = false } = {}) {
  const host = String(hostname || "").toLowerCase();
  const isProdHost = host === "backonflip.com" || host === "www.backonflip.com";
  if (isProdHost && productionPublic) return "index,follow";
  return "noindex,nofollow";
}

export function ecosystemRobotsFromWindow(opts) {
  if (typeof window === "undefined" || !window.location?.hostname) {
    return "noindex,nofollow";
  }
  return ecosystemRobotsForHost(window.location.hostname, opts);
}
